import { cva } from '@/styled-system/css';

export const labeledInputRecipe = cva({
  base: {
    'display': 'inline-block',
    'position': 'relative',
    'width': '100%',

    // Input styles
    '& > [data-c11n-component="Input"]': {
      'paddingBlockStart': 'LabeledInput.padding.top',
      'paddingBlockEnd': 'LabeledInput.padding.bottom',

      '&::placeholder': {
        transition: {
          _motionReduce: 'none',
          _motionSafe: '{transitions.LabeledInput.Input}',
        },
      },

      '&:not(:focus)::placeholder': {
        color: 'transparent.invisible',
      },
    },

    // Label styles
    '& > [data-c11n-component="Label"]': {
      'textStyle': 'body',
      'position': 'absolute',
      'insetInlineStart': 'LabeledInput.padding.horz',
      'transform': 'translateY({spacing.LabeledInput.LabelArea.padding.top.default})',
      'transformOrigin': '0 0',
      'pointerEvents': 'none',
      'truncate': true,
      'maxWidth': 'calc(100% - {spacing.LabeledInput.padding.horz})',

      '&:has(+ [data-c11n-component="Input"]:focus), &:has(+ [data-c11n-component="Input"]:not(:placeholder-shown)), &:has(+ [data-c11n-component="Input"]:-webkit-autofill), &:has(+ [data-c11n-component="Input"]:read-only)':
        {
          textStyle: 'body-xs-bold',
          transform: 'translateY({spacing.LabeledInput.LabelArea.padding.top.active})',
        },

      'transition': {
        _motionReduce: 'none',
        _motionSafe: '{transitions.LabeledInput.Label}',
      },
    },
  },
  variants: {
    fluid: {
      true: {},
      false: {
        width: 'auto',
      },
    },
    readOnly: {
      true: {
        '& > [data-c11n-component="Label"]': {
          insetInlineStart: 'LabeledInput.padding.horz-readOnly',
        },
      },
      false: {},
    },
  },
});
